<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="openDataScope"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="角色名稱" prop="roleName">
        <a-input v-model="form.roleName" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="角色標識" prop="roleKey">
        <a-input v-model="form.roleKey" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="權限範圍" prop="dataScope">
        <a-select placeholder="請選擇" v-model="form.dataScope" style="width: 100%">
          <a-select-option v-for="(d, index) in dataScopeOptions" :key="index" :value="d.value">{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="數據權限" v-show="form.dataScope == 2">
        <a-checkbox @change="handleCheckedTreeExpand($event)">
          展開/摺疊
        </a-checkbox>
        <a-checkbox @change="handleCheckedTreeNodeAll($event)">
          全選/全不選
        </a-checkbox>
        <a-checkbox @change="handleCheckedTreeConnect($event)" :checked="form.deptCheckStrictly" :disabled="deptCheckedKeys.length > 0">
          父子聯動
          <a-tooltip>
            <template slot="title">
              當勾選項為空時方可切換模式，
              可以點擊”全不選“後再次切換。
            </template>
            <a-icon type="question-circle-o" />
          </a-tooltip>
        </a-checkbox>
        <a-tree
          v-model="deptCheckedKeys"
          checkable
          :checkStrictly="!form.deptCheckStrictly"
          :expanded-keys="deptExpandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="deptOptions"
          @expand="onExpandDept"
          :replaceFields="defaultProps"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitDataScope">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getRole, dataScope, deptTreeSelect } from '@/api/system/role'
import { treeFindParentIds } from '@/utils/ruoyi'

export default {
  name: 'CreateDataScopeForm',
  components: {
  },
  data () {
    return {
      submitLoading: false,
      // 數據範圍選項
      dataScopeOptions: [
        {
          value: '1',
          label: '全部數據權限'
        },
        {
          value: '2',
          label: '自定義數據權限'
        },
        {
          value: '3',
          label: '本部門數據權限'
        },
        {
          value: '4',
          label: '本部門及以下數據權限'
        },
        {
          value: '5',
          label: '僅本人數據權限'
        }
      ],
      deptExpandedKeys: [],
      autoExpandParent: false,
      deptCheckedKeys: [],
      halfCheckedKeys: [],
      // 部門列表
      deptOptions: [],
      formTitle: '',
      // 表單參數
      form: {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
        roleSort: 0,
        status: '0',
        deptIds: [],
        deptCheckStrictly: true,
        remark: undefined
      },
      // 是否顯示彈出層（數據權限）
      openDataScope: false,
      deptExpand: true,
      deptNodeAll: false,
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'id'
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onExpandDept (expandedKeys) {
      this.deptExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // 所有部門節點數據
    getDeptAllCheckedKeys () {
      // 全選與半選
      return this.deptCheckedKeys.concat(this.halfCheckedKeys)
    },
    getAllDeptNode (nodes) {
      if (!nodes || nodes.length === 0) {
        return []
      }
      nodes.forEach(node => {
        this.deptCheckedKeys.push(node.id)
        return this.getAllDeptNode(node.children)
      })
    },
    handleCheckedTreeNodeAll (value) {
      if (value.target.checked) {
        this.getAllDeptNode(this.deptOptions)
      } else {
        this.deptCheckedKeys = []
        this.halfCheckedKeys = []
      }
    },
    handleCheckedTreeExpand (value) {
      if (value.target.checked) {
        const treeList = this.deptOptions
        for (let i = 0; i < treeList.length; i++) {
          this.deptExpandedKeys.push(treeList[i].id)
        }
      } else {
        this.deptExpandedKeys = []
      }
    },
    // 樹權限（父子聯動）
    handleCheckedTreeConnect (value) {
      this.form.deptCheckStrictly = !this.form.deptCheckStrictly
    },
    /** 根據角色ID查詢部門樹結構 */
    getDeptTree (roleId) {
      return deptTreeSelect(roleId).then(response => {
        this.deptOptions = response.data.depts
        return response
      })
    },
    onCheck (checkedKeys, info) {
      if (!this.form.deptCheckStrictly) {
        let currentCheckedKeys = []
        if (this.deptCheckedKeys.checked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.deptCheckedKeys.checked)
        }
        if (this.deptCheckedKeys.halfChecked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.deptCheckedKeys.halfChecked)
        }
        this.deptCheckedKeys = currentCheckedKeys
      } else {
        // 半選節點
        this.halfCheckedKeys = info.halfCheckedKeys
        this.deptCheckedKeys = checkedKeys
      }
    },
    onClose () {
      this.openDataScope = false
    },
    // 取消按鈕
    cancel () {
      this.openDataScope = false
      this.reset()
    },
    // 表單重置
    reset () {
      this.deptExpand = true
      this.deptNodeAll = false
      this.deptExpandedKeys = []
      this.autoExpandParent = false
      this.deptCheckedKeys = []
      this.halfCheckedKeys = []
      this.form = {
        id: undefined,
        roleName: undefined,
        roleKey: undefined,
        roleSort: 0,
        status: '0',
        deptIds: [],
        deptCheckStrictly: true,
        remark: undefined
      }
    },
    /** 分配數據權限操作 */
    handleDataScope (row) {
      this.reset()
      const deptTreeSelect = this.getDeptTree(row.id)
      getRole(row.id).then(response => {
        this.form = response.data
        this.openDataScope = true
        this.$nextTick(() => {
          deptTreeSelect.then(res => {
            this.deptCheckedKeys = res.data.checkedKeys

            // 過濾回顯時的半選中node(父)
            if (this.form.deptCheckStrictly) {
              this.deptCheckedKeys.forEach(id => {
                const parentIds = treeFindParentIds(this.deptOptions, id)
                parentIds.forEach(nodeId => {
                  if (!this.deptCheckedKeys.includes(nodeId) && !this.halfCheckedKeys.includes(nodeId)) {
                    this.halfCheckedKeys.push(nodeId)
                  }
                })
              })
            }
          })
        })
        this.formTitle = '分配數據權限'
      })
    },
    /** 提交按鈕（數據權限） */
    submitDataScope: function () {
      if (this.form.id !== undefined) {
        this.form.deptIds = this.getDeptAllCheckedKeys()
        this.submitLoading = true
        dataScope(this.form).then(response => {
          this.$message.success(
            '修改成功',
            3
          )
          this.openDataScope = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      }
    }
  }
}
</script>
